/**
 * Trạng thái nộp dự toán
 */
export default {
  /**
   * Chờ duyệt
   */
  Waiting: 1,
  /**
   * Gửi trả
   */
  Reject: 2,
  /**
   * Đã kiểm tra
   */
  Complete: 3,
  /**
   * Chưa nộp
   */
  NotSubmit: 0,
  /**
   * đang xử lý
   */
  Processing: 4,
  /**
   * Thất bại
   */
  Fail: -1,
};
